"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmSlider = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
exports.SmSlider = (0, react_1.forwardRef)((_a, ref) => {
    var { variant = 'dual', size = 'medium', min = 0, max = 100, disabled, onChange } = _a, props = __rest(_a, ["variant", "size", "min", "max", "disabled", "onChange"]);
    const [minValue, setMinValue] = (0, react_1.useState)(min);
    const [maxValue, setMaxValue] = (0, react_1.useState)(max);
    const sliderClassName = (0, classnames_1.default)('c-slider', `-${size}`, {
        '-disabled': disabled,
    });
    const minValueRef = (0, react_1.useRef)(null);
    const maxValueRef = (0, react_1.useRef)(null);
    const range = (0, react_1.useRef)(null);
    const getPercent = (0, react_1.useCallback)((value) => Math.round(((value - min) / (max - min)) * 100), [min, max]);
    (0, react_1.useEffect)(() => {
        if (maxValueRef.current) {
            const minPercent = getPercent(minValue);
            const maxPercent = getPercent(+maxValueRef.current.value);
            if (range.current) {
                range.current.style.left = `${minPercent}%`;
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [minValue, getPercent]);
    (0, react_1.useEffect)(() => {
        if (minValueRef.current) {
            const minPercent = getPercent(+minValueRef.current.value);
            const maxPercent = getPercent(maxValue);
            if (range.current) {
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
        else if (range.current) {
            const maxPercent = getPercent(maxValue);
            range.current.style.left = `0%`;
            range.current.style.width = `${maxPercent}%`;
        }
    }, [maxValue, getPercent]);
    (0, react_1.useEffect)(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange({ curMin: minValue, curMax: maxValue });
    }, [minValue, maxValue, onChange]);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: sliderClassName }),
        variant === 'dual' && (react_1.default.createElement("input", { className: (0, classnames_1.default)('c-slider__thumb -left', {
                '-front': minValue > max - 100,
            }), type: "range", min: min, max: max, value: minValue, disabled: disabled, ref: minValueRef, onChange: (event) => {
                const value = Math.min(Number(event.target.value), maxValue);
                setMinValue(value);
            } })),
        react_1.default.createElement("input", { className: "c-slider__thumb -right", type: "range", min: min, max: max, value: maxValue, disabled: disabled, ref: maxValueRef, onChange: (event) => {
                const value = Math.max(Number(event.target.value), minValue);
                setMaxValue(value);
            } }),
        react_1.default.createElement("div", { className: "c-slider__bar" },
            react_1.default.createElement("div", { className: "c-slider__track" }),
            react_1.default.createElement("div", { ref: range, className: "c-slider__range" }))));
});
//# sourceMappingURL=index.js.map